module.exports = __webpack_public_path__ + "media/images/pc/banner/hokepon_reserve_brand-7448edb92c00d876cebe054ed421b819.png";